import PubSub from "underpub-js";

var HeroComplex = function (options) {
	this.options = {
		$el: false,
		baseClass: 'mol-HeroComplex',
	};

	$.extend(true, this.options, options);
};

HeroComplex.prototype.init = function () {
	var self = this;

	self.$arrowPrev = self.options.$el.find(`.${self.options.baseClass}__arrow--prev`);
	self.$arrowNext = self.options.$el.find(`.${self.options.baseClass}__arrow--next`);

	self.$carousel = self.options.$el.find('.el-Carousel');
	self.carouselId = self.$carousel.data('id');

	self.bindEvents();
};

HeroComplex.prototype.bindEvents = function () {
	var self = this;

	self.$arrowPrev.on('click', function (e) {
		e.preventDefault();
		PubSub.publish('Carousel:previousSlideIfChild', {
			$parent: self.options.$el
		});
	});

	self.$arrowNext.on('click', function (e) {
		e.preventDefault();
		PubSub.publish('Carousel:nextSlideIfChild', {
			$parent: self.options.$el
		});
	});
};

export default HeroComplex;
